// Shared definition of the general settings form, used by both the desktop
// and mobile layouts. Field keys match the payload of PUT setting/0.

export const toggleGroups = [
  {
    id: 'inventory',
    icon: 'mdi-package-variant-closed',
    title: 'settingSection_inventory',
    subtitle: 'settingSection_inventoryHint',
    items: [
      { key: 'negativeInventory', label: 'negativeInventory', on: 'yes' },
      { key: 'negative_inventory_return_purchase', label: 'Negative inventory in purchase return invoice', on: 'yes' },
      { key: 'showPurchasePriceInSell', label: 'showPurchasePriceInSell' },
      { key: 'showLastPurchaseFee', label: 'showing-product-price-in-sell-invoice', off: 'deactive' },
      { key: 'showCodeProductInName', label: 'showCodeProductInName' },
      { key: 'getGolePriceAuto', label: 'getGolePriceAuto', gold: true }
    ]
  },
  {
    id: 'invoice',
    icon: 'mdi-receipt-text-outline',
    title: 'settingSection_invoice',
    subtitle: 'settingSection_invoiceHint',
    items: [
      { key: 'reservedInvoice', label: 'reservedInvoice' },
      { key: 'customerRequiredForInvoice', label: 'customerRequiredForInvoice' },
      { key: 'autoPrintInvoiceInOtherAccounts', label: 'autoPrintInvoiceInOtherAccounts' }
    ]
  },
  {
    id: 'customers',
    icon: 'mdi-account-group-outline',
    title: 'settingSection_customers',
    subtitle: 'settingSection_customersHint',
    items: [
      { key: 'preventDuplicateMobile', label: 'preventDuplicateMobile' },
      { key: 'preventDuplicateNationalCode', label: 'preventDuplicateNationalCode' },
      { key: 'happyBirthdaySMS', label: 'happyBirthdaySMS' },
      { key: 'usersWelcomeSMS', label: 'usersWelcomeSMS' }
    ]
  },
  {
    id: 'branch',
    icon: 'mdi-source-branch',
    title: 'settingSection_branch',
    subtitle: 'settingSection_branchHint',
    items: [
      { key: 'limitBranchInvoice', label: 'limitBranchInvoice' },
      { key: 'limitBranchUser', label: 'limitBranchUser' },
      { key: 'limitBranchProduct', label: 'limitBranchProduct' },
      { key: 'limitBranchPayment', label: 'limitBranchPayment' },
      { key: 'limitBranchCheck', label: 'limitBranchCheck' },
      { key: 'limitBranchCost', label: 'limitBranchCost' },
      { key: 'limitBranchDocument', label: 'limitBranchDocument' },
      { key: 'limitBranchEntrepot', label: 'limitBranchEntrepot' },
      { key: 'branchValidStore', label: 'branchValidStore' }
    ]
  }
]

export const detailFields = [
  { key: 'commissionDetail', label: 'commissionDetail' },
  { key: 'shippingDetail', label: 'shippingDetail' },
  { key: 'processingDetail', label: 'processingDetail' },
  { key: 'penaltyCancellingDetail', label: 'penaltyCancellingDetail' }
]

export const contactFields = [
  { key: 'nationalCode', label: 'national-code', icon: 'mdi-card-account-details-outline', inputmode: 'numeric' },
  { key: 'financialCode', label: 'financial-code', icon: 'mdi-pound', inputmode: 'numeric' },
  { key: 'mobile', label: 'mobile', icon: 'mdi-cellphone', inputmode: 'tel' },
  { key: 'phone', label: 'phone', icon: 'mdi-phone-outline', inputmode: 'tel' },
  { key: 'email', label: 'email', icon: 'mdi-email-outline', inputmode: 'email' },
  { key: 'postalCode', label: 'postal-code', icon: 'mdi-mailbox-outline', inputmode: 'numeric' }
]

// Self-contained settings modules that load and save on their own.
export const modules = [
  { id: 'accounting', icon: 'mdi-calculator-variant-outline', title: 'accounting', component: 'accounting', fill: true },
  { id: 'invoicePrint', icon: 'mdi-printer-outline', title: 'InvoicePrint', component: 'invoice-print-settings', fill: true },
  { id: 'customerPanel', icon: 'mdi-storefront-outline', title: 'customerPanelTitle', component: 'customer-panel-settings', fill: true }
]

// `hidden: true` keeps a module out of the UI without deleting it.
const allPaymentModules = [
  { id: 'pos', icon: 'mdi-credit-card-wireless-outline', title: 'pos', component: 'pos', hidden: true },
  { id: 'zibal', icon: 'mdi-wallet-outline', title: 'zibal', component: 'zibal-settings' },
  { id: 'zarinpal', icon: 'mdi-cash-fast', title: 'zarinpal', component: 'zarinpal-settings' },
  { id: 'karina', icon: 'mdi-bank-outline', title: 'karinaSamane', component: 'karina-settings' }
]

// Customer panel switches (config_control keys, saved by CustomerPanelSettings
// via configControl — not part of the general settings payload).
export const customerPanelItems = [
  { key: 'registerPreInvoice', label: 'customerPanelRegisterPreInvoice', hint: 'customerPanelRegisterPreInvoiceHint' }
]

export const paymentModules = allPaymentModules.filter(m => !m.hidden)

export function onValue (item) {
  return item.on || 'active'
}

export function offValue (item) {
  return item.off === undefined ? null : item.off
}

export function isOn (form, item) {
  return form[item.key] === onValue(item)
}
